import actions from "./actions";

const initState = {
    createOtpState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.OTP_CREATE_REQUEST:
            return {
                ...state,
                createOtpState: 'request',
            };
        case actions.OTP_CREATE_SUCCESS:
            return {
                ...state,
                createOtpState: 'success',
            };
        case actions.OTP_CREATE_ERROR:
            return {
                ...state,
                createOtpState: 'error',
            };
        default:
            return state;
    }
}
